/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvrySearchResultContainer containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum expandRefinersCount {
    all = 'all',
    one = 'one',
    two = 'two',
    three = 'three',
    four = 'four'
}

export const enum preferredViewMode {
    cardView = 'cardView',
    listView = 'listView',
    compactView = 'compactView'
}

export interface IDlvrySearchResultContainerConfig extends Msdyn365.IModuleConfig {
    enableProdutDescription?: boolean;
    useStickyFilter?: boolean;
    itemsPerPage?: number;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    expandRefinersCount?: expandRefinersCount;
    disableAvailabilityCheckUnauthorized?: boolean;
    includeAttributes?: boolean;
    enableAffiliationBasedPricing?: boolean;
    updateRefinerPanel?: boolean;
    className?: string;
    clientRender?: boolean;
    alcoholRefinerRecordId?: string;
    transitRefinerRecordId?: string;
    tobaccoRefinerRecordId?: string;
    cocacolaRefinerRecordId?: string;
    bamaRefinerRecordId?: string;
    dutyFreeSugarRefinerRecordId?: string;
    norturaRefinerRecordId?: string;
    preferredViewMode?: preferredViewMode;
    productScopeAttributeRecordId?: string;
    productScopeAttributeValue?: string;
}

export interface IDlvrySearchResultContainerResources {
    filterText: string;
    doneText: string;
    doneAriaLabel: string;
    productListOrderQuantityLabel: string;
    productListActionsLabel: string;
    productListItemText: string;
    discount: string;
    lineAmount: string;
    yes: string;
    no: string;
    productListItemNumberText: string;
    productListItemNameText: string;
    productListUnitNameText: string;
    productListPriceText: string;
    buyNowButtonText: string;
    noResultsForRefinersText: string;
    resultCategoryNotFoundText: string;
    resultSearchNotFoundText: string;
    paginationAriaLabel: string;
    priceFree: string;
    priceRangeSeparator: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    searchTextPrefix: string;
    numberOfProducts: string;
    numberOfSearchResults: string;
    oneProduct: string;
    categoryLinkAriaLabel: string;
    sortByDropdownLabel: string;
    sortByOptionNameAsc: string;
    sortByOptionNameDesc: string;
    sortByOptionPriceAsc: string;
    sortByOptionPriceDesc: string;
    sortByOptionRatingDesc: string;
    sortByOptionBestSelling: string;
    sortByOptionNewScore: string;
    sortByOptionTrendingScore: string;
    sortByOptionRelevanceDesc: string;
    placeholderTextMax: string;
    minLabel: string;
    maxLabel: string;
    rangeNameFormat: string;
    validationErrorNotNumber: string;
    validationErrorNotRange: string;
    searchText: string;
    clearAllText: string;
    choiceSummaryLabel: string;
    choiceFormat: string;
    choiceRangeValueFormat: string;
    choiceAriaLabel: string;
    closeAriaLabel: string;
    modalTitle: string;
    modalCloseButtonText: string;
    minValueSliderThumbAriaLabel: string;
    maxValueSliderThumbAriaLabel: string;
    featureSimilarLooksTitle: string;
    featureSimilarDescriptionTitle: string;
    productCountAriaLabel: string;
    singleProductCountAriaLabel: string;
    swatchItemAriaLabel: string;
    refineItemsAriaLabel: string;
    refineItemAriaLabel: string;
    addToCartText: string;
    updateCartText: string;
    removeFromCartText: string;
    outOfStockText: string;
    defaultWishlistName: string;
    addToWishlistButtonText: string;
    removeFromWishlistButtonText: string;
    addedProductToWishlistText: string;
    productsAddedToCart: string;
    productsRemovedFromCart: string;
    productsUpdatedInCart: string;
    toastErrorHeader: string;
    toastGoToCart: string;
    toastNoAccessToProduct: string;
    addToOrderTemplateHeader: string;
    noOrderTemplatesMessage: string;
    noOrderTemplatesDescription: string;
    createAnOrderTemplateButtonText: string;
    createNewOrderTemplateButtonText: string;
    cancelOrderTemplateCreationButtonText: string;
    selectTemplatesText: string;
    addToTemplateButtonText: string;
    lineItemsText: string;
    createOrderTemplateHeader: string;
    orderTemplateTitle: string;
    orderTemplateNameAriaLabel: string;
    createOrderTemplateDescription: string;
    defaultOrderTemplateName: string;
    createOrderTemplateButtonText: string;
    cancelNewOrderTemplateCreationButtonText: string;
    viewOrderTemplateButtonText: string;
    continueShoppingButtonText: string;
    itemAddedToOrderTemplateHeaderItemOneText: string;
    itemAddedToOrderTemplateHeaderItemFormatText: string;
    itemAddedToOrderTemplateHeaderMessageText: string;
    duplicatedProductsHeader: string;
    duplicatedProductsDescription: string;
    updateQuantityButtonText: string;
    cancelDuplicateItemsButtonText: string;
    addToOrderTemplateButtonText: string;
    addToOrderTemplateButtonTooltip: string;
    selectionActionsText: string;
    selectionActionsButtonText: string;
    selectionActionsMissingLicenseText: string;
    productListTotalPriceText: string;
    searchPlaceholderText: string;
    searchEmptySearchTermText: string;
    priceErrorText: string;
    availabilityError: string;
    inCartTooltipText: string;
    transitTooltip: string;
    agreementProductTooltip: string;
    refinerCategoryTitle: string;
    viewModeCardText: string;
    viewModeListText: string;
    viewModeCompact: string;
    expiredText: string;
    addToCartButtonText: string;
    priceNotLoggedInText: string;
    noResultsFilterValuesText: string;
    depositSuffixText: string;
}

export interface IDlvrySearchResultContainerProps<T> extends Msdyn365.IModule<T> {
    resources: IDlvrySearchResultContainerResources;
    config: IDlvrySearchResultContainerConfig;
    slots: {
        quickview: React.ReactNode[];
        productComparisonButton: React.ReactNode[];
    };
}
